import './homepage.scss'
import {getPropsFromState} from "../../redux/mapStateToProps";
import {connect} from "react-redux";
import MainBlock from "../../components/homepage/MainBlock/MainBlockV2";
import EventsBlock from "../../components/homepage/EventsBlock/EventsBlock";
import VideosBlock from "../../components/homepage/VideosBlock/VideosBlock";
import BannerBlock from "../../components/homepage/BannerBlock/BannerBlock";
import NewsBlock from "../../components/homepage/NewsBlock/NewsBlock";
import TravelBlock from "../../components/homepage/TravelBlock/TravelBlock";
import ProjectBlock from "../../components/homepage/ProjectBlock/ProjectBlock";
import {GetSliderBanner} from "../../redux/actions";
import {useEffect} from "react";

function Homepage(props){
    const {sliderBanner, advertisement} = props
    const banner = window?.innerWidth > 1050 ? advertisement?.[0] : advertisement

    useEffect(() => {
        // props.GetSliderBanner('BANNER')
    },[])

    return <div className={'homepage-wrapper'}>
        <MainBlock/>
        <div className={'home-news-block'}>
            <div className={'home-news-left-block'}>
                {/*<EventsBlock/>*/}
                <VideosBlock/>
            </div>
            {
                window?.innerWidth > 1050 && <div className={'home-news-right-block'}>
                    {
                        !!advertisement?.length &&  <BannerBlock sliderBanner={banner}/>
                    }
                    <NewsBlock/>
                    {
                        advertisement?.length > 1 && window.innerWidth > 1050 && advertisement?.slice(1)?.map((item) => {
                            return <BannerBlock sliderBanner={item} key={item?.id}/>
                        })
                    }
                </div>
            }
        </div>
        <TravelBlock/>
        <ProjectBlock/>
        {
            window?.innerWidth < 1050 && <div className={'home-news-right-block'}>
                {
                    !!advertisement?.length &&  <BannerBlock sliderBanner={banner}/>
                }
                <NewsBlock/>
                {
                    advertisement?.length > 1 && window.innerWidth > 1050 && advertisement?.slice(1)?.map((item) => {
                        return <BannerBlock sliderBanner={item} key={item?.id}/>
                    })
                }
            </div>
        }
    </div>
}
const mapStateToProps = (state) => {
    return getPropsFromState(state, [
        'staticTexts',
        'slider',
        'sliderBanner',
        'advertisement',
    ])
};
const mapDispatchToProps = {
    GetSliderBanner,
};
export default connect(mapStateToProps,mapDispatchToProps)(Homepage);
